<template>
  <div>
    <v-container fluid class="content-wrapper">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Members
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <v-btn
            depressed
            rounded
            small
            color="blue"
            class="white--text font-weight-bold"
            @click="goBack"
          >
            <v-icon color="black" small class="mr-2">
              mdi-arrow-left
            </v-icon>
            Back
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" lg="10">
          <v-card
            class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
            elevation="3"
            style="border-radius: 24px;"
          >
            <v-card-actions>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  color="black"
                  depressed
                  rounded
                  large
                  class="white--text font-weight-bold mb-2"
                  @click="dialogAdd = true"
                >
                  <v-icon color="white">
                    $vuetify.icons.plus
                  </v-icon>
                  {{ 'Add Member' }}
                </v-btn>
              </v-col>
              <v-col v-if="false" cols="12" md="4">
                <search-text
                  :text="'Search by name'"
                  :value="'text'"
                  @searchTextChanged="searchTextChanged"
                  @keypress.enter.native.prevent="triggerSearch"
                  @triggerSearch="triggerSearch"
                  data-cy="name"
                ></search-text>
              </v-col>
            </v-card-actions>
            <TableMembers
              v-if="adminMemberId"
              ref="table"
              :url-api="'/api/v1/users/institution/' + adminMemberId"
              :url-api-delete="'/api/v1/users/institution/' + adminMemberId + '/remove-member'"
              :url-api-add-as-admin="'/api/v1/users/institution/' + adminMemberId + '/add-as-admin'"
              :urlApiGetHostingRepresentative="'/api/v1/hosting-institutions/' + adminMemberId"
              :search="search"
              :search-attributes="[]"
              :adminProvider="true"
              @delete="deleteHandler"
              :key="tableKey"
            >
            </TableMembers>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog persistent v-model="dialogAdd" max-width="675px">
        <v-card class="py-8 px-16">
          <v-card-title>
            <v-row class="mx-0 px-2" align="center">
              <v-col cols="11" class="text-center d-flex justify-center align-center">
                Add Member
              </v-col>
              <v-col cols="1">
                <v-btn fab small text @click="dialogAdd = false">
                  <v-icon color="neutral500">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="my-6"></v-divider>
          <v-card-text>
            <label>Email</label>
            <v-text-field
              class="mt-4 required"
              v-model="member.email"
              :placeholder="'Email'"
              outlined
              :rules="emailRules()"
              rounded
              clearable
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-row style="width: 100%">
              <v-col cols="6">
                <v-btn
                  block
                  depressed
                  rounded
                  large
                  class="neutral800--text font-weight-bold"
                  color="neutral"
                  outlined
                  @click="dialogAdd = false"
                  >{{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  :disabled="!this.member.email"
                  block
                  depressed
                  rounded
                  large
                  class="white--text font-weight-bold"
                  color="black"
                  @click="addMember"
                  >{{ $t('save') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import util from '@/mixins/util.js';
import EventBus from '@/helpers/event-bus.js';
import SearchText from '@/components/shared/search/SearchText';
import TableMembers from '@/components/provider-member/TableMembers';

export default {
  name: 'AdminMembersOfInstitutions',
  mixins: [util],
  components: {
    TableMembers,
    SearchText,
  },
  data: () => ({
    search: {},
    tableKey: 0,
    tableKey2: 1,
    adminMemberId: null,
    adminMemberUrl: '',
    dialogAdd: false,
    queryAdminMember: '',
    member: {
      email: null,
    },
  }),
  mounted() {
    if (this.isFirstTime() && this.$store.getters.roles !== 'super-admin') {
      this.$router.push({
        name: 'Marketplace',
      });
    }

    this.adminMemberUrl = this.$route.query.adminMember;

    this.adminMemberId =
      this.$store.getters.roles === 'provider' && this.adminMemberUrl
        ? this.$route.params.id
        : null;

    this.queryAdminMember = this.$route.query.adminMember;
  },
  methods: {
    triggerSearch() {
      this.$refs.table.triggerSearch();
      this.forceTableRerender();
    },
    searchTextChanged(obj) {
      console.log('[App] searchTextChanged');
      this.search[obj.value] = obj.search;
    },
    searchSelectChanged(obj) {
      console.log('[App] searchSelectChanged');
      this.search[obj.value] = obj.search;
    },
    clear() {
      EventBus.$emit('clear');
      this.$nextTick(() => {
        this.triggerSearch();
        this.forceTableRerender();
      });
    },
    deleteHandler() {
      this.forceTableRerender();
    },
    forceTableRerender() {
      this.tableKey += 1;
    },
    addMember() {
      EventBus.$emit('waiting', true);
      if (this.adminMemberId) {
        this.axios
          .post('/api/v1/users/institution/' + this.adminMemberId + '/add-member', this.member)
          .then(() => {
            EventBus.$emit('snackbar', {
              text: 'New member added successfully',
            });
            this.dialogAdd = false;
            this.forceTableRerender();
          })
          .catch(error => {
            console.log({ error });
            EventBus.$emit('snackbar', {
              text: error.response.data,
              color: 'warning',
            });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      }
    },
    goBack() {
      if (
        this.queryAdminMember &&
        this.$route.query.fromTable &&
        this.$store.getters.roles === 'provider'
      ) {
        const fromTable = this.$route.query;
        this.$router.push({
          name: 'HostingInstitutions',
          query: fromTable,
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
